module.exports = __webpack_public_path__ + "img/wha.6bd92ee6.webp";